const context = "agro";
const abrev = "agro";

const MODULO_PROPRIEDADE = "PROPRIEDADE";
const MODULO_ATENDIMENTO = "ATENDIMENTOAGRICOLA";

const relatorios = [
    {
        path: '/agro/relatorios/exportacaodados',
        name: 'relatorio-agro-exportacao-dados',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/exportacao/ExportacaoDados.vue')
    },
    {
        path: '/agro/relatorios/exportacaodetalhes/:id',
        name: 'relatorio-agro-exportacao-detalhes',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/exportacao/ExportacaoDetalhes.vue')
    },
]

export default [
    {
        path: "/agro/cockpit",
        name: "agro-cockpit",
        meta: { contexto: context, abrev: abrev },
        component: () => import("../components/cockpit/CockpitAgro"),
    },
    {
        path: '/agro/cultura',
        name: 'agro-cultura',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/cultura/Cultura'),
        children: [
            {
                path: 'list',
                name: 'agro-cultura-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/cultura/CulturaList'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-cultura-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/cultura/CulturaManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-cultura-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/cultura/CulturaManage')
                    }
                ]
            },
        ]
    },
    {
        path: '/agro/cultivar',
        name: 'agro-cultivar',
        meta: { contexto: context, abrev: abrev, modulo: MODULO_ATENDIMENTO },
        component: () => import('@/components/agro/cultivar/Cultivar'),
        children: [
            {
                path: 'list',
                name: 'agro-cultivar-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/cultivar/CultivarList'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-cultivar-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/cultivar/CultivarManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-cultivar-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/cultivar/CultivarManage')
                    }
                ]
            },
        ]
    },
    /**
     * @deprecated Essas classes serao depreciadas e nao deverao ser usadas.
     */
    
    // {
    //     path: '/agro/fasecultivo',
    //     name: 'agro-fasecultivo',
    //     meta: { contexto: context, abrev: abrev, modulo: MODULO_ATENDIMENTO },
    //     component: () => import('@/components/agro/fasecultivo/FaseCultivo'),
    //     children: [
    //         {
    //             path: 'list',
    //             name: 'agro-fasecultivo-list',
    //             meta: { contexto: context, abrev: abrev },
    //             component: () => import('@/components/agro/fasecultivo/FaseCultivoList')
    //         },
    //         {
    //             path: 'new',
    //             name: 'agro-fasecultivo-new',
    //             component: () => import('@/components/agro/fasecultivo/FaseCultivoManage')
    //         },
    //         {
    //             path: 'edit/:id',
    //             name: 'agro-fasecultivo-edit',
    //             component: () => import('@/components/agro/fasecultivo/FaseCultivoManage')
    //         }
    //     ]
    // },
    {
        // Tabela: tiportr
        path: '/agro/tipo-agrovisita',
        name: 'agro-tipo-agrovisita',
        meta: { contexto: context, abrev: abrev, modulo: MODULO_ATENDIMENTO },
        component: () => import('@/components/agro/tipo-agrovisita/TipoAgroVisita'),
        children: [
            {
                path: 'list',
                name: 'agro-tipo-agrovisita-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/tipo-agrovisita/TipoAgroVisitaList'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-tipo-agrovisita-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/tipo-agrovisita/TipoAgroVisitaManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-tipo-agrovisita-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/tipo-agrovisita/TipoAgroVisitaManage')
                    }
                ]
            },
        ]
    },
    {
        // Tabela: assuntortr
        path: '/agro/assunto-agrovisita',
        name: 'agro-assunto-agrovisita',
        meta: { contexto: context, abrev: abrev, modulo: MODULO_ATENDIMENTO },
        component: () => import('@/components/agro/assunto-agrovisita/AssuntoAgroVisita'),
        children: [
            {
                path: 'list',
                name: 'agro-assunto-agrovisita-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/assunto-agrovisita/AssuntoAgroVisitaList'),
                children:
                [
                    {
                        path: 'new',
                        name: 'agro-assunto-agrovisita-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/assunto-agrovisita/AssuntoAgroVisitaManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-assunto-agrovisita-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/assunto-agrovisita/AssuntoAgroVisitaManage')
                    }
                ]
            },
        ]
    },
    {
        path: '/agro/propriedade',
        name: 'agro-propriedade',
        meta: { contexto: context, abrev: abrev, modulo: MODULO_PROPRIEDADE },
        component: () => import('@/components/agro/propriedade/Propriedade'),
        children: [
            {
                path: 'list',
                name: 'agro-propriedade-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/propriedade/PropriedadeList'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-propriedade-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/propriedade/PropriedadeManage'),
                        props: { header: true, content: true }
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-propriedade-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/propriedade/PropriedadeManage'),
                        props: { header: true, content: true }
                    }
                ]
            },
        ]
    },
    {
        path: '/agro/unidademedidaarea',
        name: 'agro-unidademedidaarea',
        meta: { contexto: context, abrev: abrev, modulo: MODULO_PROPRIEDADE },
        component: () => import('@/components/agro/unidademedidaarea/UnidadeMedidaArea'),
        children: [
            {
                path: 'list',
                name: 'agro-unidademedidaarea-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/unidademedidaarea/UnidadeMedidaAreaList')
            },
            {
                path: 'new',
                name: 'agro-unidademedidaarea-new',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/unidademedidaarea/UnidadeMedidaAreaManage')
            },
            {
                path: 'edit/:id',
                name: 'agro-unidademedidaarea-edit',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/unidademedidaarea/UnidadeMedidaAreaManage')
            }
        ]
    },
    {
        path: '/agro/tipotalhao',
        name: 'agro-tipotalhao',
        meta: { contexto: context, abrev: abrev, modulo: MODULO_PROPRIEDADE },
        component: () => import('@/components/agro/tipotalhao/TipoTalhao'),
        children: [
            {
                path: 'list',
                name: 'agro-tipotalhao-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/tipotalhao/TipoTalhaoList')
            },
            {
                path: 'new',
                name: 'agro-tipotalhao-new',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/tipotalhao/TipoTalhaoManage')
            },
            {
                path: 'edit/:id',
                name: 'agro-tipotalhao-edit',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/tipotalhao/TipoTalhaoManage')
            }
        ]
    },
    // Novos
    {
        path: '/agro/safra',
        name: 'agro-safra',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/safra/Safra'),
        children: [
            {
                path: 'list',
                name: 'agro-safra-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/safra/SafraList'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-safra-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/safra/SafraManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-safra-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/safra/SafraManage')
                    }
                ]
            },
        ]
    },
    {
        path: '/agro/fasefenologica',
        name: 'agro-fasefenologica',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/fasefenologica/FaseFenologica'),
        children: [
            {
                path: 'list',
                name: 'agro-fasefenologica-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/fasefenologica/FaseFenologicaList'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-fasefenologica-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/fasefenologica/FaseFenologicaManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-fasefenologica-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/fasefenologica/FaseFenologicaManage')
                    }
                ]
            },
        ]
    },
    {
        path: '/agro/tiporecomendacao',
        name: 'agro-tiporecomendacao',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/tiporecomendacao/TipoRecomendacao'),
        children: [
            {
                path: 'list',
                name: 'agro-tiporecomendacao-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/tiporecomendacao/TipoRecomendacaoList')
            },
            {
                path: 'new',
                name: 'agro-tiporecomendacao-new',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/tiporecomendacao/TipoRecomendacaoManage')
            },
            {
                path: 'edit/:id',
                name: 'agro-tiporecomendacao-edit',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/tiporecomendacao/TipoRecomendacaoManage')
            }
        ]
    },
    {
        path: '/agro/ocorrencia',
        name: 'agro-ocorrencia',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/ocorrencia/Ocorrencia'),
        children: [
            {
                path: 'list',
                name: 'agro-ocorrencia-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/ocorrencia/OcorrenciaList'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-ocorrencia-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/ocorrencia/OcorrenciaManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-ocorrencia-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/ocorrencia/OcorrenciaManage')
                    }
                ]
            },
        ]
    },
    {
        path: '/agro/niveltecnologico',
        name: 'agro-niveltecnologico',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/niveltecnologico/NivelTecnologico'),
        children: [
            {
                path: 'list',
                name: 'agro-niveltecnologico-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/niveltecnologico/NivelTecnologicoList')
            },
            {
                path: 'new',
                name: 'agro-niveltecnologico-new',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/niveltecnologico/NivelTecnologicoManage')
            },
            {
                path: 'edit/:id',
                name: 'agro-niveltecnologico-edit',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/niveltecnologico/NivelTecnologicoManage')
            }
        ]
    },
    {
        path: '/agro/cli/grupoeconomico',
        name: 'cli-grupoeconomico',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/grupoeconomico/GrupoEconomico'),
        children: [
            {
                path: 'list',
                name: 'cli-grupoeconomico-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/grupoeconomico/GrupoEconomicoList')
            },
            {
                path: 'new',
                name: 'cli-grupoeconomico-new',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/grupoeconomico/GrupoEconomicoManage')
            },
            {
                path: 'edit/:id',
                name: 'cli-grupoeconomico-edit',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/grupoeconomico/GrupoEconomicoManage')
            }
        ]
    },
    {
        path: '/agro/cli/areainteresse',
        name: 'cli-areainteresse',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/areainteresse/AreaInteresse'),
        children: [
            {
                path: 'list',
                name: 'cli-areainteresse-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/areainteresse/AreaInteresseList')
            },
            {
                path: 'new',
                name: 'cli-areainteresse-new',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/areainteresse/AreaInteresseManage')
            },
            {
                path: 'edit/:id',
                name: 'cli-areainteresse-edit',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/areainteresse/AreaInteresseManage')
            }
        ]
    },
    {
        path: '/agro/tipoocorrencia',
        name: 'agro-tipoocorrencia',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/tipoocorrencia/TipoOcorrencia'),
        children: [
            {
                path: 'list',
                name: 'agro-tipoocorrencia-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/tipoocorrencia/TipoOcorrenciaList')
            },
            {
                path: 'new',
                name: 'agro-tipoocorrencia-new',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/tipoocorrencia/TipoOcorrenciaManage')
            },
            {
                path: 'edit/:id',
                name: 'agro-tipoocorrencia-edit',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/tipoocorrencia/TipoOcorrenciaManage')
            }
        ]
    },
    {
        path: '/agro/motivo',
        name: 'agro-motivo',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/motivo/Motivo'),
        children: [
            {
                path: 'list',
                name: 'agro-motivo-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/motivo/MotivoList'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-motivo-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/motivo/MotivoManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-motivo-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/motivo/MotivoManage')
                    }
                ]
            },
        ]
    },
    {
        path: '/agro/sugestao',
        name: 'agro-sugestao',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/sugestao/Sugestao'),
        children: [
            {
                path: 'list',
                name: 'agro-sugestao-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/sugestao/SugestaoList')
            },
            {
                path: 'new',
                name: 'agro-sugestao-new',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/sugestao/SugestaoManage')
            },
            {
                path: 'edit/:id',
                name: 'agro-sugestao-edit',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/sugestao/SugestaoManage')
            }
        ]
    },
    {
        path: '/agro/visita',
        name: 'agro-visita',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/agro-visita/AgroVisita'),
        children: [
            {
                path: 'list',
                name: 'agro-visita-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/agro-visita/AgroVisitaList'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-visita-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/agro-visita/AgroVisitaManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-visita-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/agro-visita/AgroVisitaManage')
                    },
                    {
                        path: '/agro/:idvisita/visita/item',
                        name: 'agro-visita-item',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/agro-visita-item/AgroVisitaItem'),
                        children: [
                            {
                                path: 'new',
                                name: 'agro-visita-item-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/agro/agro-visita-item/AgroVisitaItemManage')
                            },
                            {
                                path: 'edit/:id',
                                name: 'agro-visita-item-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/agro/agro-visita-item/AgroVisitaItemManage')
                            }
                        ]
                    },
                ]
            },
        ]
    },
    // {
    //     path: '/agro/:idvisita/visita/item',
    //     name: 'agro-visita-item',
    //     meta: { contexto: context, abrev: abrev },
    //     component: () => import('@/components/agro/agro-visita-item/AgroVisitaItem'),
    //     children: [
    //         {
    //             path: 'new',
    //             name: 'agro-visita-item-new',
    //             meta: { contexto: context, abrev: abrev },
    //             component: () => import('@/components/agro/agro-visita-item/AgroVisitaItemManage')
    //         },
    //         {
    //             path: 'edit/:id',
    //             name: 'agro-visita-item-edit',
    //             meta: { contexto: context, abrev: abrev },
    //             component: () => import('@/components/agro/agro-visita-item/AgroVisitaItemManage')
    //         }
    //     ]
    // },
    {
        path: '/agro/planosafra',
        name: 'agro-planosafra',
        component: () => import('@/components/agro/planosafra/PlanoSafra'),
        children: [
            {
                path: 'list',
                name: 'agro-planosafra-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/planosafra/PlanoSafraList'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-planosafra-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/planosafra/PlanoSafraManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-planosafra-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/planosafra/PlanoSafraManage')
                    }
                ]
            },
        ]
    },
    {
        path: '/agro/fenologia',
        name: 'agro-fenologia',
        component: () => import('@/components/agro/fenologia/Fenologia'),
        children: [
            {
                path: 'list',
                name: 'agro-fenologia-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/agro/fenologia/FenologiaList'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-fenologia-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/fenologia/FenologiaManage')
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-fenologia-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/agro/fenologia/FenologiaManage')
                    }
                ]
			},
		]
	},
    {
        path: '/agro/empresas/feriado',
        name: `agro-feriados`,
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/feriado/FeriadoRoute.vue'),
        children: [
            {
                path: 'list',
                name: `agro-feriados-list`,
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/feriado/FeriadoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: `agro-feriados-new`,
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/feriado/FeriadoManager.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: `agro-feriados-edit`,
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/feriado/FeriadoManager.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/agro/empresas/turno',
        name: `agro-turnos`,
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/turno/TurnoRoute.vue'),
        children: [
            {
                path: 'list',
                name: `agro-turno-list`,
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/turno/TurnoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: `agro-turno-new`,
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/turno/TurnoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: `agro-turno-edit`,
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/turno/TurnoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/agro/cliente',
        name: 'agro-cliente',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/cliente/ClienteRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'agro-cliente-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/cliente/ClienteListRoute.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-cliente-new',
                        meta: { contexto: context, abrev: abrev },
                        redirect: { name: 'agro-cliente-dados-cadastrais-new' },
                        component: () => import('@/components/vendas/cliente/ClienteManage.vue'),
                        children: [
                            {
                                path: 'dados-cadastrais',
                                name: 'agro-cliente-dados-cadastrais-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/cliente/AbaDadosCadastraisRoute.vue')
                            },
                            {
                                path: 'politica-comercial',
                                name: 'agro-cliente-politica-comercial-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/cliente/AbaPoliticaComercial.vue')
                            },
                            {
                                path: 'analise-comercial',
                                name: 'agro-cliente-analise-comercial-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/cliente/AbaAnaliseComercial.vue')
                            },
                        ]
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-cliente-edit',
                        meta: { contexto: context, abrev: abrev },
                        redirect: { name: 'agro-cliente-dados-cadastrais-edit' },
                        component: () => import('@/components/vendas/cliente/ClienteManage.vue'),
                        children: [
                            {
                                path: 'dados-cadastrais',
                                name: 'agro-cliente-dados-cadastrais-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/cliente/AbaDadosCadastraisRoute.vue')
                            },
                            {
                                path: 'politica-comercial',
                                name: 'agro-cliente-politica-comercial-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/cliente/AbaPoliticaComercial.vue')
                            },
                            {
                                path: 'analise-comercial',
                                name: 'agro-cliente-analise-comercial-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/cliente/AbaAnaliseComercial.vue')
                            },
                        ]
                    },
                ]
            },
        ]
    },
    {
        path: '/agro/clientes/regiao',
        name: 'agro-regiao',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/promotor/regiao/RegiaoRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'agro-regiao-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/promotor/regiao/RegiaoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-regiao-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/regiao/RegiaoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-regiao-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/promotor/regiao/RegiaoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/agro/clientes/tipoendereco',
        name: 'agro-tipoendereco',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/tipoendereco/TipoEndereco.vue'),
        children: [
            {
                path: 'list',
                name: 'agro-tipoendereco-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/tipoendereco/TipoEnderecoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-tipoendereco-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/tipoendereco/TipoEnderecoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-tipoendereco-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/tipoendereco/TipoEnderecoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/agro/clientes/transportadora',
        name: 'agro-transportadora',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/transportadora/Transportadora.vue'),
        children: [
            {
                path: 'list',
                name: 'agro-transportadora-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/transportadora/TransportadoraList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-transportadora-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/transportadora/TransportadoraManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-transportadora-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/transportadora/TransportadoraManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/agro/clientes/situacao',
        name: 'agro-situacao',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/situacao/Situacao.vue'),
        children: [
            {
                path: 'list',
                name: 'agro-situacao-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/situacao/SituacaoList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-situacao-new',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/situacao/SituacaoManage.vue')
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-situacao-edit',
                        meta: { contexto: context, abrev: abrev },
                        component: () => import('@/components/vendas/situacao/SituacaoManage.vue')
                    },
                ]
            },
        ]
    },
    {
        path: '/agro/tipopedido',
        name: 'agro-tipopedido-new',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/tipopedido/TipoPedidoManage.vue')
    },
    {
        path: '/agro/tabelapreco',
        name: 'agro-tabelapreco-new',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/tabelapreco/TabelaprecoManage.vue')
    },
    {
        path: '/agro/campanha',
        name: 'agro-campanha-new',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/campanha/CampanhaManage.vue')
    },
    {
        path: '/agro/fornecedor',
        name: 'agro-fornecedor-new',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/fornecedor/FornecedorManage.vue')
    },
    {
        path: '/agro/empresa',
        name: 'agro-empresa',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/empresa/EmpresaRoute.vue'),
        children: [
            {
                path: 'list',
                name: 'agro-empresa-list',
                meta: { contexto: context, abrev: abrev },
                component: () => import('@/components/vendas/empresa/EmpresaList.vue'),
                children: [
                    {
                        path: 'new',
                        name: 'agro-empresa-new',
                        meta: { contexto: context, abrev: abrev },
                        redirect: { name: 'agro-empresa-dados-cadastrais-new' },
                        component: () => import('@/components/vendas/empresa/EmpresaManage.vue'),
                        children: [
                            {
                                path: 'dados-cadastrais',
                                name: 'agro-empresa-dados-cadastrais-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/empresa/AbaDadosCadastrais.vue')
                            },
                            {
                                path: 'politica-comercial',
                                name: 'agro-empresa-politica-comercial-new',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/empresa/AbaPoliticaComercial.vue')
                            },
                        ]
                    },
                    {
                        path: 'edit/:id',
                        name: 'agro-empresa-edit',
                        meta: { contexto: context, abrev: abrev },
                        redirect: { name: 'agro-empresa-dados-cadastrais-edit' },
                        component: () => import('@/components/vendas/empresa/EmpresaManage.vue'),
                        children: [
                            {
                                path: 'dados-cadastrais',
                                name: 'agro-empresa-dados-cadastrais-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/empresa/AbaDadosCadastrais.vue')
                            },
                            {
                                path: 'politica-comercial',
                                name: 'agro-empresa-politica-comercial-edit',
                                meta: { contexto: context, abrev: abrev },
                                component: () => import('@/components/vendas/empresa/AbaPoliticaComercial.vue')
                            },
                        ]
                    },
                ]
            },
        ]
    },
    {
        path: '/agro/licenca',
        name: 'agro-new-licenca',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/vendas/licenca/LicencaManage.vue')
    },
    {
        path: '/agro/geoanalise/ocorrencia',
        name: 'mapa-geoanalise-por-ocorrencia',
        meta: { contexto: context, abrev: abrev },
        component: () => import('@/components/agro/geoanalise/geoanalise-por-ocorrencia/MapaGeoanalisePorOcorrencia'),
	},
	...relatorios
];